import './ErrorTemplate.less';
import React from 'react';
import Button from "../../../bootstrap/components/button/Button";
import __ from "../../i18n";
import {useHistory} from 'react-router-dom';


export default function ErrorTemplate(
    {
        imageSrc,
        title,
        description
    }
) {
    const history = useHistory();

    return <div className="error-template">
        {/*<div className="image-row">
            <img src={imageSrc} alt={title}/>
        </div>*/}
        <div className="title">{title}</div>
        <div className="description">{description}</div>
        <div className="button-row">
            <Button
                appearance="solid-primary"
                icon="arrow-left"
                title={__('Go back')}
                size="large"
                onClick={() => history.goBack()}
            />
        </div>
    </div>;
}
